import axiosClient, { responseBody } from '@/api/axios-client';
import { mapToIUser } from '@/api/user-mapper';

export interface StoreItem {
  slug: string;
  name: string;
  type: string;
  price_sparks: number;
  payload: { gem?: string };
  owned: boolean;
  can_buy: boolean;
}

export const getStore = () => {
  return axiosClient
    .get<{ items: StoreItem[] }>('/api/store')
    .then(responseBody);
};

export const buyItem = (slug: string) => {
  return axiosClient
    .post<{ user: unknown; item: StoreItem }>(`/api/store/${slug}/buy`)
    .then(responseBody)
    .then((data) => ({
      user: mapToIUser(data.user),
      item: data.item,
    }));
};
